import { AxiosInstance } from "axios";
import { UserDto } from "../dtos/UserDtos.ts";

const userSearchUrl = (searchQuery: string) => `users/search/?q=${searchQuery}`;

export function searchUsers(axios: AxiosInstance, searchQuery: string) {
  return axios.get<UserDto[]>(userSearchUrl(searchQuery));
}
